document.addEventListener('DOMContentLoaded', function() {
  function selectSubscription() {
    const radios = document.querySelectorAll('.shopify_subscriptions_fieldset input[type="radio"]');
    
    if (radios.length >= 2) {
      // Второй radio — это подписка
      radios[1].checked = true;
      radios[1].click();
      radios[1].dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    return false;
  }

  // Пробуем сразу и с задержками на случай медленной загрузки виджета
  if (!selectSubscription()) {
    setTimeout(function() {
      if (!selectSubscription()) {
        setTimeout(selectSubscription, 1000);
      }
    }, 500);
  }
});
